import { KnowledgeBaseFacade } from '@agent/core/store/knowledge-base/knowledge-base.facade';
import { Component, Input, OnChanges } from '@angular/core';

import { UntilDestroy } from '@contact/upgrade';

import { ResponseModel } from '../../models/responseModel';
import { OwiMdr, OwiResponse } from '../models/responseModel';
import { KnowledgeBaseOwiApiService } from '../services/knowledge-base-OWI-api.service';

@UntilDestroy()
@Component({
  selector: 'knowledge-base-search',
  templateUrl: 'knowledge-base-search.component.html',
  styleUrls: ['./knowledge-base-search.component.scss'],
})
export class KnowledgeBaseSearchComponent implements OnChanges {
  @Input() readonly searchValue: string;
  @Input() readonly canCopyPaste: boolean;
  responseModels: ResponseModel[] = [];
  loading = false;

  constructor(
    private readonly knowledgeBaseOwiApiService: KnowledgeBaseOwiApiService,
    private readonly knowledgeBaseFacade: KnowledgeBaseFacade
  ) {}

  ngOnChanges(): void {
    this.responseModels = [];
    if (this.searchValue) {
      this.loading = true;
      this.knowledgeBaseOwiApiService.getTextSearchResults(this.searchValue).subscribe(
        (response: OwiResponse) => {
          this.responseModels = response.listeMdr.map((responseModel: OwiMdr) => ({
            id: responseModel.mdrNum,
            label: responseModel.libelle,
            content: responseModel.contenu,
            linkType: responseModel.typeLien,
            link: responseModel.lien,
            linkText: responseModel.texteLien,
            attachments: responseModel.attachments.map(owiAttachment => ({
              responseModelId: owiAttachment.mdrNum,
              name: owiAttachment.name,
              content: owiAttachment.content,
            })),
          }));

          this.knowledgeBaseFacade.searchResults(this.responseModels);
          this.loading = false;
        },
        error => {
          console.log('ERROR: ' + JSON.stringify(error));
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } else {
      this.knowledgeBaseFacade.searchResults([]);
    }
  }
}
